/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Mastercard: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <rect width='32' height='32' rx='16' />
    <path d='M18.81 21.03H13.2V10.97h5.62v10.06Z' fill='#FF5F00' />
    <path d='M13.55 16c0-2.04.96-3.86 2.45-5.03A6.42 6.42 0 0 0 5.6 16 6.41 6.41 0 0 0 16 21.03 6.38 6.38 0 0 1 13.55 16Z' fill='#EB001B' />
    <path d='M26.4 16A6.41 6.41 0 0 1 16 21.03a6.38 6.38 0 0 0 0-10.06A6.42 6.42 0 0 1 26.4 16Z' fill='#F79E1B' />
  </React.Fragment>
)
